import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OBJECT_URL_CACHE_BYTES, OBJECT_URL_CACHE_COUNT } from '../config';
var MIME_BY_EXT = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  mp4: 'video/mp4',
  webm: 'video/webm'
};
export var mimeForPath = function mimeForPath(rel) {
  var _rel$split$pop$toLowe, _rel$split$pop, _MIME_BY_EXT$ext;
  var ext = (_rel$split$pop$toLowe = (_rel$split$pop = rel.split('.').pop()) === null || _rel$split$pop === void 0 ? void 0 : _rel$split$pop.toLowerCase()) !== null && _rel$split$pop$toLowe !== void 0 ? _rel$split$pop$toLowe : '';
  return (_MIME_BY_EXT$ext = MIME_BY_EXT[ext]) !== null && _MIME_BY_EXT$ext !== void 0 ? _MIME_BY_EXT$ext : 'application/octet-stream';
};
/**
 * Object URLs for artifact entries (step screenshots, video), used by the
 * post-v1 detail views. THE CACHE OWNS REVOCATION: components never call
 * revokeObjectURL on unmount (avoids revoke-while-img-loading races and
 * remount flicker). URLs die on LRU eviction or releaseAll().
 */
export var ArtifactUrlCache = /*#__PURE__*/function () {
  function ArtifactUrlCache(client) {
    var maxBytes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : OBJECT_URL_CACHE_BYTES;
    var maxUrls = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : OBJECT_URL_CACHE_COUNT;
    _classCallCheck(this, ArtifactUrlCache);
    _defineProperty(this, "map", new Map());
    _defineProperty(this, "inflight", new Map());
    /** URLs for entries too large for the LRU — revoked only on releaseAll. */
    _defineProperty(this, "unmanaged", []);
    _defineProperty(this, "total", 0);
    _defineProperty(this, "released", false);
    this.client = client;
    this.maxBytes = maxBytes;
    this.maxUrls = maxUrls;
  }
  return _createClass(ArtifactUrlCache, [{
    key: "getUrl",
    value: function () {
      var _getUrl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(rel, signal) {
        var _this = this;
        var hit, running, p;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.released) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", null);
            case 1:
              hit = this.map.get(rel);
              if (!hit) {
                _context.next = 2;
                break;
              }
              // refresh recency
              this.map["delete"](rel);
              this.map.set(rel, hit);
              return _context.abrupt("return", hit.url);
            case 2:
              running = this.inflight.get(rel);
              if (!running) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", running);
            case 3:
              p = this.client.readBytes(rel, signal).then(function (bytes) {
                if (!bytes) return null;
                var url = URL.createObjectURL(new Blob([bytes], {
                  type: mimeForPath(rel)
                }));
                // The cache may have been released while the read was in flight —
                // an orphaned URL would pin its Blob for the tab's lifetime.
                if (_this.released) {
                  URL.revokeObjectURL(url);
                  return null;
                }
                if (bytes.byteLength > _this.maxBytes) {
                  // Oversized entries bypass the LRU (evicting everything else AND
                  // the fresh entry itself would return an already-revoked URL).
                  _this.unmanaged.push(url);
                  return url;
                }
                _this.map.set(rel, {
                  url: url,
                  bytes: bytes.byteLength
                });
                _this.total += bytes.byteLength;
                _this.evict(rel);
                return url;
              })["finally"](function () {
                _this.inflight["delete"](rel);
              });
              this.inflight.set(rel, p);
              return _context.abrupt("return", p);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUrl(_x, _x2) {
        return _getUrl.apply(this, arguments);
      }
      return getUrl;
    }()
  }, {
    key: "releaseAll",
    value: function releaseAll() {
      this.released = true;
      var _iterator = _createForOfIteratorHelper(this.map.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var url = _step.value.url;
          URL.revokeObjectURL(url);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(this.unmanaged),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _url = _step2.value;
          URL.revokeObjectURL(_url);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.map.clear();
      this.unmanaged.length = 0;
      this.inflight.clear();
      this.total = 0;
    }
  }, {
    key: "evict",
    value: function evict(justInserted) {
      var _iterator3 = _createForOfIteratorHelper(this.map),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            v = _step3$value[1];
          if (this.total <= this.maxBytes && this.map.size <= this.maxUrls) return;
          if (key === justInserted) return; // never revoke the URL being returned
          this.map["delete"](key);
          this.total -= v.bytes;
          URL.revokeObjectURL(v.url);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
}();